import { useTranslation } from 'react-i18next';

import defaultImagePlaceholder from 'assets/svg/profile-placeholder.svg';
import { useCurrentUser } from 'providers/cache/cachedDataHooks';
import { extractUserName } from 'utils/extractUserName';
import { convertToThumbnail300 } from 'utils/thumbnails';

import DataDetails from './DataDetails';

const LoggedUserDetails = () => {
  const { currentUser } = useCurrentUser();
  const { t } = useTranslation('checkout');

  const prepareContent = () => {
    if (currentUser) {
      return {
        name: extractUserName(currentUser),
        image: currentUser?.imageUrl ? convertToThumbnail300(currentUser.imageUrl) : defaultImagePlaceholder,
      };
    }
  };

  return <DataDetails header={`${t('buyer-reassignment.user')}:`} isCircleImage={true} content={prepareContent()} />;
};

export default LoggedUserDetails;
